import { CRM_API, RequestHelper } from "utils";

const RUTA = "reporte-606";
export const Reporte606Service = (() => {
  const imprimirPDF = () =>
    RequestHelper(CRM_API).get(`${RUTA}/imprimir`, { formato: "PDF" });

  const descargarExcel = () =>
    RequestHelper(CRM_API).get(`${RUTA}/imprimir`, { formato: "EXCEL" }, true);

  const descargarCSV = () =>
    RequestHelper(CRM_API).get(`${RUTA}/imprimir`, { formato: "CSV" }, true);

  return { imprimirPDF, descargarExcel, descargarCSV };
})();
